import React, {useState, useEffect} from 'react';

import KindergartensList from '../../../kindergartens/list/components/KindergartensPage/KindergartensPage';


const benefits_fixed = [
  "5bfb996f0b7fb2059b8828c9",
  "5c16b5a22f8be751f04fce92",
  "60e81561904ae40729056dc4"
]

const Step5 = ({ formData, onChange }) => {

  const [isFixed, setIsFixed] = useState(false);

  useEffect(()=>{

    setIsFixed(benefits_fixed.includes(formData.benefits.type));

  },[formData.benefits.type])


  

  const handleSchoolSelect = (kgId) => {
    const newArr = formData.selectedSchools.includes(kgId) ? formData.selectedSchools.filter(l=>l!==kgId) : [...formData.selectedSchools, kgId] ;
    onChange('selectedSchools', newArr );
  };

  return (
    <div className="form-section form-section--wide">
      <h2 className="form-section-title">{isFixed ? 'Обрана пільна призначена тільки для одного садочку' :'Обрання садочку' }</h2>
      <KindergartensList isListView={true} isChecked={true} listChecked={formData.selectedSchools} onCheck={handleSchoolSelect} isFixed={isFixed} uncheckAll={()=>onChange('selectedSchools', [])}/>
    </div>
  );
};

export default Step5;